import * as React from 'react';
import { styled } from 'styled-components';
import Checkbox from '@sdk/components/forms/Checkbox';

const CHECKBOX_BORDER_COLOR = 'rgba(0, 0, 0, 0.28)';

type ContainerProps = {
  hoverComponent?: any;
  forceShow?: boolean;
};

// @TODO figure out how to style props without AnyStyledComponent
const Container = styled.div<ContainerProps>`
  margin-right: 6px;
  display: ${(props): string => (props.forceShow ? 'flex' : 'none')};

  ${(props) => props.hoverComponent}:hover & {
    display: flex;
  }
`;

type Props = {
  isSelected?: boolean;
  showSelect?: boolean;
  toggleSelection?: () => void;
  hoverComponent?: any;
};

const EventBoxSelect: React.FC<React.PropsWithChildren<Props>> = ({
  isSelected,
  showSelect,
  toggleSelection,
  hoverComponent,
}) => {
  return (
    <Container hoverComponent={hoverComponent} forceShow={showSelect}>
      <Checkbox value={isSelected} onChange={toggleSelection} borderColor={CHECKBOX_BORDER_COLOR} />
    </Container>
  );
};

export default EventBoxSelect;
